module.exports = __webpack_public_path__ + "img/banner_tripartite.78e9388a.png";